import { FormEvent } from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { PasswordInput } from '../ui/password-input';
import { Label } from '../ui/label';

interface LoginPageProps {
  username: string;
  setUsername: (username: string) => void;
  password: string;
  setPassword: (password: string) => void;
  handleLogin: (e: FormEvent<HTMLFormElement>) => Promise<void>;
}

export function LoginPage({
  username,
  setUsername,
  password,
  setPassword,
  handleLogin,
}: LoginPageProps) {
  return (
    <div className="mx-auto w-full max-w-lg">
      <Card className="shadow-lg">
        <CardHeader>
          <CardTitle>Acessar backoffice</CardTitle>
          <CardDescription>
            Faça login com seu usuário autorizado para manter as informações de orçamento.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form className="space-y-5" onSubmit={handleLogin}>
            <div className="space-y-2">
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                type="text"
                placeholder="seu.username"
                value={username}
                autoComplete="username"
                onChange={(event) => setUsername(event.target.value)}
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <PasswordInput
                id="password"
                value={password}
                autoComplete="current-password"
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </div>

            <Button type="submit" className="w-full">
              Entrar
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
